export const isEnv = (env: 'dev' | 'prod') => process.env.REACT_APP_ENV === env;
